export const INTERNAL_TRANSFER_STEPS_TYPES = {
  TRANSFER_DETAILS: 1,
  REVIEW_AND_PAY: 2,
};

export const INTERNAL_TRANSFER_STEP_TITLE = {
  [INTERNAL_TRANSFER_STEPS_TYPES.TRANSFER_DETAILS]: 'Transfer between accounts',
  [INTERNAL_TRANSFER_STEPS_TYPES.REVIEW_AND_PAY]: 'Review & Pay',
};
